import styled from "styled-components";
import { Modal as AntModal } from "antd";
import { SpinBonusBg } from "@assets";

export const Modal = styled(AntModal)`
	/* position: relative; */
	.ant-modal-content {
		border: none !important;
		background-image: url(${SpinBonusBg}) !important;
		background-size: contain !important;
		background-repeat: no-repeat !important;
		background-position: center !important;
		width: 365px !important;
		height: 423px !important;
		/* height: 3px; */
		box-shadow: none !important;
		background-color: transparent !important;
	}
	@media screen and (max-width: 413px) {
		width: 265px !important;
		height: 323px !important;
		.ant-modal-content {
			width: 265px !important;
			height: 323px !important;
		}
	}
`;

export const AmountWrapper = styled.div`
	margin-top: 220px;
	color: #FFCE00;
	text-align: center;
	font-size: 27px;
	font-style: normal;
	font-weight: 700;
	line-height: normal;
	@media screen and (max-width: 413px) {
		margin-top: 160px;
		font-size: 25px;
	}
`;

export const OkWrapper = styled.div`
	width: 40px;
	height: 36px;
	margin: 20px; /* Add margin to the top and right */
	position: absolute; /* Position the div absolutely */
	top: 0; /* Position it at the top */
	right: 0; /* Position it at the right */
	display: flex;
	justify-content: center;
	align-items: center;
	border: 1.5px solid #FFFFFF;
	border-radius: 12px;
	background: #015ab6;
	cursor: pointer;
	text-align: center;
	font-size: 16px;
	font-style: normal;
	font-weight: 600;
	line-height: normal;
`;

export const ExpiredText = styled.div`
	margin: 10px 0 0 0;
	color: #DADADA;
	text-align: center;
	font-size: 12px;
	font-style: normal;
	font-weight: 500;
	line-height: normal;
	@media screen and (max-width: 413px) {
		font-size: 9px;
		margin-top: 0px;
	}
`;


export const ExpiredDate = styled.div`
	margin: 10px 0 0 0;
	color: #DADADA;
	text-align: center;
	font-size: 12px;
	font-style: normal;
	font-weight: 500;
	line-height: normal;
	@media screen and (max-width: 413px) {
		font-size: 9px;
		margin-top: 0px;
	}
`;
